import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import config from "../../../config/config";

export const GoalScoreCard = ({ data }) => {
  const { i18n } = useTranslation();

  const groupedData = data?.reduce((acc, match) => {
    const leagueKey = match.league;
    if (!acc[leagueKey]) acc[leagueKey] = [];
    acc[leagueKey].push(match);
    return acc;
  }, {});

  return (
    <div className="space-y-3 p-3 max-w-4xl mx-auto">
      {Object.entries(groupedData || {}).map(([league, matches], idx) => (
        <div key={idx} className="rounded-xl overflow-hidden bg-white shadow-sm border border-[#228B22]/10">
          {/* League Header */}
          <div className="bg-gradient-to-r from-[#228B22] to-[#1F5F1F] px-4 py-3 flex justify-between items-center">
            <span className="text-sm font-bold text-white truncate pr-2">
              {league}
            </span>
            <span className="bg-white/20 text-white text-xs font-medium px-2 py-1 rounded-full">
              {matches.length} {matches.length > 1 ? 'Matches' : 'Match'}
            </span>
          </div>

          {/* Match List */}
          <div className="divide-y divide-gray-100">
            {matches.map((event, index) => {
              const isFinished = event.status === "FT";
              const homeWon = parseInt(event.homeGoal) > parseInt(event.awayGoal);
              const awayWon = parseInt(event.awayGoal) > parseInt(event.homeGoal);

              return (
                <div 
                  key={index} 
                  className="px-4 py-3"
                >
                  <div className="flex items-center justify-between mb-1">
                    <span className="text-xs font-medium text-gray-500">
                      {moment(event.event).format("h:mm A")}
                    </span>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                      isFinished 
                        ? 'bg-[#228B22]/10 text-[#228B22]' 
                        : 'bg-[#FFD700]/10 text-[#B8860B]'
                    }`}>
                      {config.goal_status[event.status]}
                    </span>
                  </div>

                  {/* Home Team */}
                  <div className="flex items-center justify-between py-1">
                    <span className={`text-sm ${homeWon ? 'text-gray-900 font-semibold' : 'text-gray-700'}`}>
                      {i18n.language === "en" ? event.homeTeam : event.homeTeamMyan}
                    </span>
                    <span className={`w-8 h-8 flex items-center justify-center rounded-full text-sm ${
                      homeWon 
                        ? 'bg-[#228B22] text-white font-bold' 
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                      {event.homeGoal === "NE" ? "-" : event.homeGoal}
                    </span>
                  </div>

                  {/* Away Team */}
                  <div className="flex items-center justify-between py-1">
                    <span className={`text-sm ${awayWon ? 'text-gray-900 font-semibold' : 'text-gray-700'}`}>
                      {i18n.language === "en" ? event.awayTeam : event.awayTeamMyan}
                    </span>
                    <span className={`w-8 h-8 flex items-center justify-center rounded-full text-sm ${
                      awayWon 
                        ? 'bg-[#228B22] text-white font-bold' 
                        : 'bg-gray-100 text-gray-800'
                    }`}>
                      {event.awayGoal === "NE" ? "-" : event.awayGoal}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};
